<template>
  <SvgBase iconName="IconPDF" :height="24" :width="21">
    <g filter="url(#filter0_d)">
      <path d="M17.5 19.5V7.5V6.5L12 1H0.5V19.5H17.5Z" fill="white" />
      <path
        d="M15.6288 11.8426C15.3549 11.5726 14.7468 11.4299 13.8211 11.4171C13.0939 11.4179 12.3677 11.4712 11.6482 11.5765C11.2933 11.3721 10.9269 11.1484 10.6402 10.8796C9.86749 10.1584 9.22206 9.15679 8.82092 8.05493C8.84663 7.95208 8.86978 7.86208 8.89035 7.7695C8.89035 7.7695 9.32621 5.29708 9.21049 4.46136C9.20197 4.38038 9.18296 4.30086 9.15392 4.22479L9.11663 4.12708C8.99835 3.8545 8.76563 3.56522 8.40178 3.58065L8.18192 3.57422C7.77563 3.57422 7.44521 3.78122 7.35906 4.09236C7.09549 5.06565 7.36806 6.52108 7.86049 8.40593L7.73449 8.71322C7.38092 9.57465 6.93863 10.4425 6.54778 11.2075L6.49635 11.3065C6.08492 12.1114 5.71206 12.7941 5.37392 13.3726L5.02549 13.5578C4.99978 13.5706 4.40192 13.8882 4.26178 13.9731C3.07121 14.6841 2.28306 15.4902 2.15192 16.1305C2.11078 16.3349 2.14163 16.5959 2.35249 16.7168L2.69063 16.8865C2.83286 16.9588 2.99008 16.9967 3.14963 16.9971C3.99692 16.9971 4.98178 15.9415 6.33821 13.5745C7.94149 13.0562 9.58335 12.6658 11.2483 12.4071C12.4389 13.0769 13.9033 13.5424 14.8265 13.5424C14.9911 13.5424 15.1325 13.5269 15.2469 13.4961C15.4163 13.4548 15.5648 13.3534 15.6648 13.2106C15.8435 12.9406 15.8808 12.5691 15.8319 12.1885C15.8012 12.0547 15.7308 11.9333 15.6301 11.8401L15.6288 11.8426ZM2.96578 16.3542C3.12006 15.9312 3.73206 15.0955 4.63721 14.3536C4.69378 14.3074 4.83392 14.1762 4.96249 14.0541C4.01621 15.5635 3.38235 16.1652 2.96578 16.3529V16.3542ZM8.32592 4.01136C8.59849 4.01136 8.75406 4.69793 8.76692 5.34208C8.77978 5.98622 8.62935 6.43879 8.44292 6.77308C8.28863 6.27808 8.21278 5.49765 8.21278 4.98722C8.21278 4.98722 8.20121 4.01136 8.32592 4.01136ZM6.72649 12.8069C6.91678 12.4675 7.11349 12.1088 7.31535 11.7282C7.80778 10.7974 8.11763 10.0696 8.34906 9.47179C8.78362 10.2771 9.36236 10.9957 10.0565 11.5919C10.1401 11.6626 10.2301 11.7346 10.3226 11.8054C8.95206 12.0766 7.76792 12.4058 6.72521 12.8069H6.72649ZM15.3665 12.7298C15.2829 12.7825 15.0438 12.8121 14.8908 12.8121C14.3945 12.8121 13.7799 12.5858 12.9198 12.2155C13.2502 12.1911 13.5536 12.1782 13.8262 12.1782C14.3238 12.1782 14.4716 12.1756 14.9576 12.3004C15.4436 12.4251 15.4501 12.6771 15.3665 12.7285V12.7298Z"
        fill="black"
      />
      <path
        d="M17.1527 4.60157C16.7066 3.99343 16.0843 3.28114 15.4016 2.59843C14.7189 1.91571 14.0066 1.29343 13.3984 0.847286C12.3621 0.0874285 11.8594 0 11.5714 0H1.60714C0.721286 0 0 0.721286 0 1.60714V18.9643C0 19.8501 0.721286 20.5714 1.60714 20.5714H16.3929C17.2787 20.5714 18 19.8501 18 18.9643V6.42857C18 6.14057 17.9126 5.63786 17.1527 4.60157ZM14.4913 3.50871C15.1084 4.12586 15.5919 4.68129 15.9493 5.14286H12.8559V2.05071C13.3174 2.40814 13.8741 2.89157 14.49 3.50871H14.4913ZM16.7143 18.9643C16.7143 19.1391 16.5677 19.2857 16.3929 19.2857H1.60714C1.52221 19.2847 1.44103 19.2505 1.38097 19.1905C1.3209 19.1304 1.28672 19.0492 1.28571 18.9643V1.60714C1.28571 1.43357 1.43357 1.28571 1.60714 1.28571H11.5714V5.78571C11.5714 5.95621 11.6392 6.11972 11.7597 6.24028C11.8803 6.36084 12.0438 6.42857 12.2143 6.42857H16.7143V18.9643Z"
        fill="black"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="0"
        width="20.5"
        height="23.0714"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.5" dy="1.5" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </SvgBase>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import SvgBase from './SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconPDF extends Vue {}
</script>
